// src/index.tsx
import "./styles/base.css";
import { createRoot } from "react-dom/client";
import { loadAppConfig } from "./auth/appConfig";
import { startTokenAutoRefresh } from "./auth/refresh";

const root = createRoot(document.getElementById("root")!);

async function bootstrap() {
  try {
    await loadAppConfig();                  // 1) fetch /env.json
    startTokenAutoRefresh();                // 1.5) idToken の失効前自動更新を開始
    const { default: App } = await import("./App"); // 2) import App *after* config is ready
    root.render(<App />);
  } catch (e) {
    console.error(e);
    root.render(<div style={{ padding: 20, color: "crimson" }}>
      Failed to load env.json
    </div>);
  }
}

bootstrap();
